import commonTypes from './modules/common/types';

export default {
    ...commonTypes
};
